import * as React from 'react'
import PropTypes from 'prop-types'

// @mui
import { useTheme } from '@mui/material/styles'
import { Stack, AppBar, Toolbar, IconButton } from '@mui/material'

import { bgBlur } from 'src/utils/cssStyles'

// hooks
import useResponsive from 'src/hooks/useResponsive'
// config
import { HEADER } from 'src/config-global'
// components

import Logo from 'src/components/logo'
import Iconify from 'src/components/iconify'
import { useSettingsContext } from 'src/components/settings'

Header.propTypes = {
  onOpenNav: PropTypes.func,
}

export default function Header({ onOpenNav }) {
  const theme = useTheme()

  const { themeLayout } = useSettingsContext()

  const isNavHorizontal = themeLayout === 'horizontal'

  const isDesktop = useResponsive('up', 'lg')

  const renderContent = (
    <>
      {isDesktop && isNavHorizontal && <Logo sx={{ mr: 2.5 }} />}

      <Stack spacing={1} direction="row">
        {!isDesktop && (
          <IconButton onClick={onOpenNav} sx={{ mr: 1, color: 'text.primary' }}>
            <Iconify icon="eva:menu-2-fill" />
          </IconButton>
        )}
      </Stack>

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 0.5, sm: 1.5 }}
      >
        {/* Header is now cleaner, actions moved to sidebar */}
      </Stack>
    </>
  )

  return (
    <AppBar
      sx={{
        boxShadow: 'none',
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(isDesktop && {
          display: 'none',
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  )
}
